<template>
  <Datepicker
    :value="value"
    :disabled-dates="datePickerRange"
    format="yyyy-MM-d"
    wrapper-class="pt-0 visnet-events__datepicker"
    input-class="datepicker__input"
    @input="changeDate"
  />
</template>

<script>
import MomentTimezone from 'moment-timezone';
import Datepicker from 'vuejs-datepicker';
import { FORMAT_YMD } from '@/components/shared/date-format';

export default {
  name: 'DatepickerComponent',
  components: { Datepicker },
  props: {
    value: { type: String, required: true },
    startDate: { type: String, required: true }
  },
  computed: {
    computedStartDate() {
      const createdAt = MomentTimezone(this.startDate);
      const todayYearAgo = MomentTimezone().subtract(1, 'years');

      return createdAt > todayYearAgo ? createdAt.toString() : todayYearAgo.toString();
    },
    datePickerRange() {
      return {
        from: MomentTimezone(new Date()).toDate(),
        to: MomentTimezone(new Date(this.computedStartDate))
          .subtract(1, 'days')
          .toDate()
      };
    }
  },
  methods: {
    changeDate(newDate) {
      const formattedDate = MomentTimezone(newDate).format(FORMAT_YMD);

      this.$emit('dateChange', formattedDate);
    },
    dateFormat(date) {
      return MomentTimezone(date).format(FORMAT_YMD);
    }
  }
};
</script>
